import { render } from "./Button.vue?vue&type=template&id=6e652ff7&scoped=true"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"

import "./Button.vue?vue&type=style&index=0&id=6e652ff7&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6e652ff7"

export default script